import React from "react";
import ReactDOM from "react-dom";

const ContextMenuPortal = ({ children }) => {
  return ReactDOM.createPortal(children, document.body);
};

export default ContextMenuPortal;
